const style = (theme) => ({
  icon: {
    '&.small': {
      height: theme.spacing(2),
      width: theme.spacing(2),
    },
    '&.medium': {
      height: theme.spacing(4),
      width: theme.spacing(4),
    },
    '&.large': {
      height: theme.spacing(5),
      width: theme.spacing(5),
    },
  },
})

export default style
